import React from "react";
import { CV } from "../components/cv";
import PatrikPImg from "@/assets/images/patrik-p.png";

export default function CVPatrikPochill() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Patrik Pochill";
  }, []);

  return (
    <CV
      name="Patrik Pochill"
      title="Solution Architect & Developer"
      subtitle="Solution architect for e-commerce on Optimizely, .NET and inRiver PIM"
      photo={PatrikPImg}
      summary="Software developer and solution architect with a wide array of skills. His main focus is backend development, but he is equally at home in frontend development, hosting and the requirements specification process — which gives him the overall picture needed to create efficient, smart solutions. Connects code with business value and delivers pragmatic solutions that meet both technical and business requirements."
      skills={{
        "Languages": ["C#", ".NET", "JavaScript", "TypeScript", "SQL"],
        "Frontend": ["React", "Vue", "Next.js", "CSS/SCSS"],
        "Platforms": ["Optimizely CMS/Commerce", "Episerver", "Inriver PIM", "Umbraco"],
        "Cloud & DevOps": ["Azure", "GitHub Actions", "CI/CD", "Octopus Deploy", "TeamCity", "Rack Servers"],
        "Payments": ["Klarna Checkout", "Swish", "DIBS", "Nets", "Svea"],
        "Data & Search": ["SQL", "MongoDB", "RavenDB", "Solr"],
        "AI Tooling": ["Claude Code"],
        "Methods": ["Solution Architecture", "Microservices", "Scrum", "Kanban", "E-commerce"],
      }}
      experience={[
        {
          role: "Owner, Solution Architect & Developer",
          company: "Pochill Solutions / BoldBrave",
          period: "2022 – Present",
          description:
            "Running a self-hosted (garage) startup and acting as solution architect for a ~10-person dev team. Heavy focus on Azure, hosting and CI/CD, with self-built payment solutions and integrations rather than off-the-shelf platforms.",
          highlights: [
            "Fitness24Seven — Solution Architect: Azure and CI/CD setup, web development, security and performance improvements, entrance (door access) solutions, end-user self-service, TV-screen integrations and online checkout, plus enabling other developers in the team (Azure, Umbraco, Contentful, BRP, .NET, React, Next.js, Claude Code)",
            "Pinshirt (2023 – Present) — Co-owner and solution architect building a custom T-shirt webshop from scratch, including a self-hosted rack server and Geo/GIS integrations for generating map prints (C#, Next.js, GitHub Actions, Swish)",
            "Court 22 (2022) — payment and Fortnox accounting integration, a complete Azure production environment from scratch and door-access solutions (Azure, Svea, Swish, Fortnox, C#, React)",
          ],
        },
        {
          role: "Backend & Frontend Developer, Solution Architect",
          company: "Diamir",
          period: "2019 – 2022",
          description:
            "Built both e-commerce and CMS site solutions, with a lot of work on integrations between Inriver PIM and Optimizely CMS/Commerce and the Navision ERP system, and frontend work in Vue.",
        },
        {
          role: "Backend Developer & Solution Architect",
          company: "KnowIT",
          period: "2016 – 2019",
          description:
            "Several e-commerce projects building integrations to different ERP systems, search engines and payment providers, with Optimizely CMS/Commerce as the base.",
          highlights: [
            "Carepa & RKV — B2B e-commerce on Optimizely CMS/Commerce, Find, Inriver PIM and Foundation",
            "Midsona & Hiab — B2B e-commerce with Inriver PIM imports and Salesforce integration",
            "Feetfirst — B2C e-commerce with Klarna Checkout and PIM imports",
          ],
        },
        {
          role: "Backend Developer & Technical Lead",
          company: "Avensia AB",
          period: "2012 – 2016",
          description:
            "Backend developer across various e-commerce solutions and Technical Lead for the COOP Norway solution, integrating a wide variety of systems (Optimizely, Apptus eSales, Solr, Umbraco, Inriver PIM, Step PIM, Nets, DIBS, Klarna).",
          highlights: [
            "COOP Norway (Technical Lead) — B2C e-commerce with Google Enhanced Ecommerce integration",
            "Intersport, Ahlsell & Bygghemma — warehouse, ERP and eSales integrations with Klarna Checkout",
            "Kjell & Company & Slöjd-Detaljer — NETS/DIBS card integrations, responsive sites and Inriver PIM upgrades",
          ],
        },
        {
          role: "Web Developer",
          company: "Axis Communications AB",
          period: "2011",
          description:
            "Summer internship developing a web-based tool for sharing ideas within the company (PHP, SQL, HTML, CSS, JavaScript, Selenium tests).",
        },
      ]}
      education={[
        {
          degree: "Master of Computer Science and Engineering",
          institution: "Lund University",
          year: "2007 – 2012",
        },
        {
          degree: "C++ and Web Development",
          institution: "Uppsala University",
          year: "2006",
        },
        {
          degree: "C++ Development",
          institution: "University West",
          year: "2006",
        },
      ]}
    />
  );
}
